import React from 'react'
import {LoginForm} from './login.react.js'
import {RegisterForm} from './register.react.js'

export const LoginMenu = React.createClass({
  getInitialState() {
    return {
      showLogin: false,
      showRegister: false,
    };
  },

  close(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({ showLogin: false, showRegister: false});
  },

  openLogin(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({ showLogin: true });
  },

  openRegister(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({ showRegister: true });
  },

  render: function () {
    return (
      <div>
        <LoginForm showModal={this.state.showLogin} close={this.close}/>
        <RegisterForm showModal={this.state.showRegister} close={this.close}/>
        <ul className="nav navbar-nav navbar-right">
          <li><a onClick={this.openLogin} href='#'>ログイン</a></li>
          <li><a onClick={this.openRegister} href='#'>ユーザ登録</a></li>
        </ul>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./components/loginmenu.react.js